import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
    'en': {
        welcomeMsg: 'Welcome to Your Vue.js App',
        guide: 'For a guide and recipes on how to configure / customize this project,',
        checkout: 'check out the',
        plugins: 'Installed CLI Plugins',
        links: 'Essential Links',
        ecosystem: 'Ecosystem',
        name: 'Name',
        age: 'Age',
        weight: 'Weight',
        height: 'Height',
        address: 'Address',
        city: 'City',
        zipcode: 'Zipcode',
        contactNumber: 'Contact Number',
        status: 'Status' ,
        registerDate: 'Register',
        lastUpdate: 'Last Update',
        weightData: ['Extra skinny','skinny','Average','fat','extra fatty','en-N/A'],
        heightData: ['short','average','tall','extra tall','en-N/A'],
        condition:'Health condition',
        sex: ['Male','Female'],
        gender:'Gender',
        statusData:['Reported','Forwarded to '],
        conditionData:['Not evaluated','Stable'],
        ageFrom:'Age Min',
        ageTo:'Age Max',
        search: 'Search',
        pre_health_condition:'Pre health condition',
        diabetics:'Diabetics',
        heart:'Heart diseases',
        lungs:'Lungs diseases/asthma',
        skomking:'Smoking habit',
        not_sure:'Not sure',
        dont_have:'Dont have',
        have_but_controlled:'Mild or controlled',
        high_condition:'High or severe',
        never_smoke:'Never Smoked',
        smoker_quit:'Smoker but quited',
        smoker:'Smoker',
        duration_na:'Note sure',
        duration_less_5:'Less than 5 years',
        duration_more_5:'More than 5  years',
        form_birth:'By born',
        fever:'Fever',
        cough:'Cough',
        chest_pain:'Chest pain',
        breathing_problem:'Breathing problem',
        consciousness:'Consciousness',
        symptomData: ['None', 'Mild', 'Moderate', 'Severe',''],
        hour:'Hour',
        years:'Years',
        dashboard:'Dashboard',
        task_list_urgent:'Task (Urgent)',
        task_list_pending:'Task (Pending)',
        patient_list:'Patient list',
        user_list_admin:'User List(admin)',
        hotline_users:'User List(Hotline)',
        consultants:'Consultants / Doctors',
        field_supervisor:'Field Supervisor',
        procedures:'Procedures',
        medicines:'Medicines',
        location:'Location',
        patient_report:'Case Statistics',
        location_report:'Location Report',
        hotline_report:'Hotline Statistics',
        reports:'Reports',
        users:'Users',
        settings    :'Settings',
        task_list:'Tasks',
        user_list:'User List',
        userType:['admin','hotline_users','consultants','field ambulance','field delivery'],
        userOptionsConsultant:['medicine','chest','asthama','pedoatry'],
        userOptionsAmbulance:['Ambulance','Mobile test-kit','Deleivery Medicine'],
        userOptionsDelivery:['delivery Van','Motor cycle','Cycle','On-foot'],
        userStatus:['Disabled','Active'],
        medicineGroups:['Digestive system','Cardiovascular system','Central nervous system','For pain','Musculo-skeletal disorders','Respiratory system','allergic disorders','immune system'],
        medicineType:['Tablet','Capsule','Suspension','Injection'],
        medicineWarning:['Not for Infant','Not for Kid','Prohibited during Pregnancy','Prohibited for Cardiac patient'],
        medicine_list:'Medicine List',
        medicineGroupName:'Medicine for',
        medicineTypeName:'Product Type',
        warning:'Warning if Any',
        priorityLbl:'Priority',
        priorityData:['Normal','Moderate','Urgent'],
        contactNumber_name:'Contact Number / Name',
        consultantTasks:['Request for Video/Voice conference','Prescribe Medicine','Suggest for medical examination if required',''],
        ambulanceTasks:['Hospitalize Patient','Isolate patient and house','Conduct Covid19 TEST','Collect specimen',''],
        deliveryTasks:['Supply medicine','Supply groceries ','Supply emergency Relief goods','Supply emergency Relief fund'],
        beforeAftermealData:['After Meal','Before meal'],
        durationData:['1 day','2 days','3 days','5 days','1 week','2 Week','3 week','1 Month','2 Month','3 month','1 Year','Continue'],
        quantityData:['½','1','1 ½','2','2 ½','3'],
        spoon:'Spoon',
        duration:'Duration',
        prescriptionTasks:['Purchase and start using the medicines ASAP','Please update patient\'s condition through app','Please take  the medicines in proscribed time interval','Please complete the course in prescribed time'],
        tasklist: ['Case forwarded to consultant','Case forwarded to ambulance','case forwarded to mobile Test Unit','Medicine has been prescribed'],
        distributorTypeData:['Govt','Local','Company','Individual'],
        preconditionStatus:['Don\'t have','Not sure','Moderate or controlled','Severe/High'],
        riskFactor:['Normal','Moderate','High','Severe'],
        trendData:['Unchanged','Good','Bad'],
        closeContactData:['Never','Not sure','May be','Yes'],
        locationData:['Not affected zone','Not sure','Mild Affected zone','Heavily affected area'],
        ageGroupDate:['Child','Middle age','Pre Elderly','Elderly'],
        taskGroupData:['','','','Forwarded to Consultant','Forwarded to Ambulance','Forwarded to Field','Prescribed Medicine'],
        taskStatus:['Pending','Done','Cancelled'],
        activeData:['Inactive','Active'],
        rationRequestStatus:['Pending','Processing','Delivered','Declined'],
        validityDays:[3,7,15,30],
        statusRationData:['Declined','Delivered'],
        casesData:['Covid Suspect','Non Covid case','Mental health'],
        ageGroup:['Unknown','Below 10','10 to 30 years','31 to 50 years','50 to 70 years','70 ++'],
        ageGroupRation:['Below 18','18 to 30 years','31 to 50 years','50 to 70 years','70 ++'],
        vehicleStatusData:['Idle and waiting for new order','Transit with full capacity','Transit but not full capacity','Transit  empty','in-service','Damaged in transit'],
        capacityData:['5 ton','10 ton','15 ton','25 ton','30++ ton'],
        loadingSettingData:['Carry vegetables','Can carry fruits','Fish and processed meat','Dairy','Eggs','Live chickens'],
        loadingSetting:'Load setting',
        capacityLbl:'Load Capacity',
        packagingTypeLbl:'Packing type',
        packagingTypeData:['Cartoon','Busket','Drum','Sacks','Others'],
        itemTypeLbl:'Item type',
        itemTypeData:['Vegetables','Fruits','Fish','Processed meat','Live chciken','Live goats','Live cows','Dairy Milk','Eggs'],
        packageQuantity:'Package quantity',
        approxQuantity:'Approximate Quanity',
        pickupPointName:'Pickup point',
        deliveryName:'Delivery Point name',
        transport_request:'Transport Request',
        vehicle:'Listed Vehicles',
        transport:'Transport Request',
        add_new:'Add new',
        transportrequest_list:'List of Transport Request',
        transportvehicle_list:'Listed Vehicles',
        submit:'Submit',
        rationdistributor_list:'Ration Distributor\'s list',
        locationName:'location Name',
        idNumber:'ID/IC Number',
        ward_village:'Ward/Village',
        city_union:'City/Union',
        district:'District',
        state:'State',
        enterBy:'Added by',
        active:'Active',
        action:'Action',
        distributorOrgName:'Organization Name',
        insertTime:'Time',
        risk:'Risk',
        symptom:'Symptom',
        trend:'Trend',
        patientName:'Patient name',
        patientContact:'Patient Contact',
        taskGroup:'Task Group',
        taskType:'Task Type',
        priority:'Priority',
        comments:'Comments',
        sync1:'Sync(C)',
        sync2:'Sync(P)',
        userTypeLbl:'User Type',
        optionsLbl:'Options',
        user_form:'User Registration form',
        riskFactorLbl:'Risk Factor'


    },
    'my': {
        welcomeMsg: 'Bienvenido a tu aplicación Vue.js',
        guide: 'Para una guía y recetas sobre cómo configurar / personalizar este proyecto,',
        checkout: 'revisar la',
        plugins: 'Plugins de CLI instalados',
        links: 'Enlaces esenciales',
        ecosystem: 'Ecosistema',
        name: 'Nama',
        age: 'Umur',
        weight: 'Berat badan',
        height: 'ketinggian',
        address: 'Alamat',
        city: 'City',
        zipcode: 'Kod zip',
        contactNumber: 'Telefon',
        status: 'Status' ,
        registerDate: 'Tarikh pendaftaran',
        lastUpdate: 'kemaskini terakhir',
        weightData: ['Lebih kurus','Kurus','Rata-rata','Lemak','Tambahan lemak','N/A'],
        heightData: ['Pendek','Rata-rata','Tinggi','Lebih tinggi','N/A'],
        condition:'Keadaan kesihatan',
        sex: ['Lelaki','Perempuan'],
        gender:'Jantina',
        statusData:['Reported','Forwarded to '],
        conditionData:['Tidak dinilai','Stabil'],
        ageFrom:'Umur min',
        ageTo:'Umur Max',
        search:'Carian',
        pre_health_condition:'Keadaan kesihatan pra',
        diabetics:'Pesakit kencing manis',
        heart:'Penyakit jantung',
        lungs:'Penyakit paru-paru / asma',
        skomking:'Tabiat merokok',
        not_sure:'Tidak pasti',
        dont_have:'Tidak ada',
        have_but_controlled:'Ringan atau terkawal',
        high_condition:'Tinggi atau teruk',
        never_smoke:'Tidak merokok',
        smoker_quit:'Perokok tetapi diketepikan',
        smoker:'Masih Merokok',
        duration_na:'Perhatikan pasti',
        duration_less_5:'Kurang dari 5 tahun',
        duration_more_5:'Lebih daripada 5 tahun',
        form_birth:'Oleh lahir',
        fever:'Demam',
        cough:'Batuk',
        chest_pain:'Sakit dada',
        breathing_problem:'Masalah pernafasan',
        consciousness:'Kesedaran',
        symptomData: ['Tiada', 'Ringan', 'Sederhana', 'Teruk',''],
        hour:'Jam',
        years:'tahun',
        dashboard:'Papan Pemuka',
        task_list_urgent:'Tugas (Segera)',
        task_list_pending:'Tugas (belum selesai)',
        patient_list:'senarai pesakit',
        user_list_admin:'Senarai Pengguna (admin)',
        hotline_users:'Senarai Pengguna(HotLine)',
        consultants:'Perunding / Doktor',
        field_supervisor:'Penyelia Bidang',
        procedures:'Prosedur',
        medicines:'ubat-ubatan',
        location:'Lokasi',
        patient_report:'Statistics kes',
        location_report:'Laporan Lokasi',
        hotline_report:'Statistik Hotline',
        reports:'Laporan',
        users:'Pengguna',
        settings:'Menetapkan',
        task_list:'Tugas',
        user_list:'Pengguna',
        userType:['admin','hotline_users','consultants','field ambulance','field delivery'],
        userOptionsConsultant:['medicine','chest','asthama','pedoatry'],
        userOptionsAmbulance:['Ambulance','Mobile test-kit','Deleivery Medicine'],
        userOptionsDelivery:['delivery Van','Motor cycle','Cycle','On-foot'],
        userStatus:['Disabled','Aktif'],
        medicineGroups:['Digestive system','Cardiovascular system','Central nervous system','For pain','Musculo-skeletal disorders','Respiratory system','allergic disorders','immune system'],
        medicineType:['Tablet','Capsule','Suspension','Injection'],
        medicineWarning:['Not for Infant','Not for Kid','Prohibited during Pregnancy','Prohibited for Cardiac ptient'],
        medicine_list:'Medicine List',
        medicineGroupName:'Medicine for',
        medicineTypeName:'Product Type',
        warning:'Warning if Any',
        priorityLbl:'Keutamaan',
        priorityData:['Biasa', 'Sederhana', 'Mendesak'],
        contactNumber_name:'Nombor / Nama',
        consultantTasks:['Conduct Video/Voice conference','Prescribe Medicine','Suggest for medical examination if required','Evaluate case'],
        ambulanceTasks:['Hospitalize Patient','Isolate patient and house','Conduct Covid19 TEST','Collect specimen','Evaluate case'],
        deliveryTasks:['Supply medicine','Supply groceries ','Supply emergency Relief goods','Supply emergency Relief fund'],
        beforeAftermealData:['Sebelum makan','Selepas makan'],
        durationData:['1 day','2 days','3 days','5 days','1 week','2 Week','3 week','1 Month','2 Month','3 month','1 Year','Continue'],
        quantityData:['½','1','1 ½','2','2 ½','3'],
        spoon:'Sudu',
        duration:'Tempoh',
        prescriptionTasks:['Purchase and start using the medicines ASAP','Please update patient\'s condition through app','Please take  the medicines in proscribed time interval','Please complete the course in prescribed time'],
        tasklist:['Kes dikemukakan kepada perunding', 'Kes diteruskan ke ambulans', 'Kes dikemukakan ke Unit Uji bergerak', 'Ubat telah ditentukan'],
        distributorTypeData:['Govt','Local','Company','Individual']
    }
}

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'es', // set fallback locale
    messages // set locale messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/plugins/i18n.js